import { render, staticRenderFns } from "./CadastrarEditarEventoCalendarioDialog.vue?vue&type=template&id=687157ea"
import script from "./CadastrarEditarEventoCalendarioDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarEventoCalendarioDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports